import React, {useState, useEffect} from 'react'
import Skeleton from 'react-loading-skeleton';

function WidgetBody({date, factor, horoscope, isLoading, ...props}) {
    const capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
    };

    factor = factor.replace("regular", "");
    const title = `Your Daily ${capitalizeFirstLetter(factor)} Horoscope`;


    let dateStr = ""
    if (horoscope) {
        const dateMatchRes = horoscope.match(/\w{1,3} ?\d+, ?\d{4}/gm);
        if (dateMatchRes) {
            dateStr = dateMatchRes[0];
            const trim = (str, chars) => str.split(chars).filter(Boolean).join(chars);
            horoscope = trim(horoscope.replace(dateStr, ""),":");
        }
    } else {
        horoscope = "We apologise, horoscope is not available today, please visit us few hours later."
    }

    return <div className="vc_row wpb_row vc_inner vc_row-fluid">
        <div className="wpb_column vc_column_container vc_col-sm-12">
            <div className="vc_column-inner">
                <div className="wpb_wrapper">
                    <div className="wpb_text_column wpb_content_element ">
                        <div className="wpb_wrapper">
                            <h3>{isLoading ? <Skeleton/> : title}</h3>
                            {isLoading ? <Skeleton count={1} width={50}/> : <strong>{dateStr}: </strong>}
                            {isLoading ? <Skeleton count={4}/> : horoscope}
                        </div>
                    </div>
                    <div className="wpb_raw_code wpb_content_element wpb_raw_html">
                        <div className="wpb_wrapper">
                            <span
                                className="chat_widget">Looking for more guidance about your specific situation?</span>
                            <div className="popping-chat"><a
                                href="http://t.tophoroscopetoday.com/aff_c?offer_id=2020&aff_id=2042&url_id=948&source=Site-Regular&aff_sub=TopHoroscopeToday"
                                target="_blank" rel="noopener noreferrer"> Chat with a live psychic advisor,
                                now!</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


}


export default WidgetBody;
